/**
 * Admin application entry point.
 *
 * Bootstraps the admin SPA that provides the full management
 * interface — dashboard, users, applications, roles, newsletters,
 * and settings.  Served from `/Manage/`.
 *
 * Sets the router's basePath to `/Manage` so that all programmatic
 * navigation (`push`, `replace`) and the location store
 * transparently handle the prefix.
 *
 * 1. Configures the router base path.
 * 2. Initialises the Auth module (reads token from localStorage).
 * 3. Loads the server configuration (app name + version).
 * 4. Mounts the admin root Svelte component.
 */
import { mount, unmount } from 'svelte';
import { setBasePath } from '../abstract-spa-router';
import App from './App.svelte';
import { initialize } from '../Auth';
import { loadConfiguration } from '../AppConfiguration';

/* Set base path BEFORE anything reads the location store. */
setBasePath('/Manage');

/* Auth init is async — we fire it and let App.svelte react to store changes. */
initialize();
loadConfiguration();

const app = mount(App, {
	target: document.getElementById('app')!
});

/** Unmount the Svelte app — the DOM stays frozen but no more
 * reactive updates run.  Used by logout() to prevent flicker. */
window.__destroyApp = () => unmount(app);

/** Admin SPA application instance. */
export default app;
